<script setup lang="ts">
import { ButtonSeverity } from '../../presets/button/types/buttonServerity';

const emits = defineEmits<{
  clicked: [];
}>();

const props = defineProps({
  buttonText: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  severity: {
    type: String,
    required: false,
    default: ButtonSeverity.download,
  },
  errorState: {
    type: String,
    required: false,
    default: 'pending',
  },
  icon: {
    type: String,
    required: false,
    default: 'pi-trash',
  },
  ignoreIcon: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  textClass: {
    type: Array,
    required: false,
    default: () => [],
  },
});
</script>
<template>
  <Button
    :severity="props.severity"
    class="min-w-36 transition-200 flex items-center justify-center align-middle content-center px-4 py-2 rounded-md"
    :class="props.errorState === 'error' && 'animate-sidetoside'"
    :disabled="props.disabled || props.loading"
    @click="emits('clicked')"
  >
    <span :class="props.loading ? ['opacity-0', ...props.textClass] : ['opacity-100', ...props.textClass]">{{
      props.buttonText
    }}</span>
    <i
      v-if="!ignoreIcon"
      :class="{
        'opacity-0': props.loading,
        [`opacity-100`]: !props.loading,
        pi: !props.loading,
        [`${props.icon}`]: !props.loading,
        'ml-3': !props.loading && props.buttonText !== '',
      }"
      style="font-size: 1.5rem"
    />
    <div
      v-if="props.loading"
      class="w-full flex justify-center h-7 absolute"
    >
      <ProgressSpinner
        stroke-width="8"
        class="absolute w-10 h-7"
      />
    </div>
  </Button>
</template>
